import { render, staticRenderFns } from "./Dialog_AddGood.vue?vue&type=template&id=ec001dae&scoped=true&"
import script from "./Dialog_AddGood.vue?vue&type=script&lang=js&"
export * from "./Dialog_AddGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec001dae",
  null
  
)

export default component.exports